import { CircularProgress } from '@mui/material';
import React from 'react';
import './Spinner.scss';

function Spinner() {
  return (
    <div className='spinner-overlay'>
      <CircularProgress />
    </div>
  );
}

Spinner.displayName = 'Spinner';
export default Spinner;
